import React from "react";
import {Wrapper, Nav, Map} from "./index.styled";

const Regional = () => {


  return (
    <Wrapper>
      <Nav>
        <h3>Drive Times</h3>
        <div>
          <ul>
            <li><b>SFV</b> - 18 Miles / 38 Minutes</li>
            <li><b>Westside</b> - 13 Miles / 36 Minutes</li>
            <li><b>Eastside</b> - 6 Miles / 12 Minutes</li>
            <li><b>Pasadena</b> - 12 Miles / 29 Minutes</li>
            <li><b>Silver Lake</b> - 5.4 Miles / 20 Minutes</li>
            <li><b>Santa Monica</b> - 16 Miles / 38 Minutes</li>
          </ul>
        </div>
      </Nav>

      <Map>
        <img className="center" src="/images/pages/maps/regionalMap.jpg" alt="Row primary map" />
      </Map>
    </Wrapper>
  )
}

export default Regional;
